module.exports = __webpack_public_path__ + "static/media/successVoice.14017fd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/system/music/successVoice.mp3
// module id = JihV
// module chunks = 55